import { useState } from "react";
import { TriangleAlert } from "lucide-react";

const UndoLeadModal = ({ isOpen, title = "Undo Lead", message = "Are you sure you want to undo this lead?", onCancel, onCompleteUndo, onDealMachineUndo, buttonColor = "red" }) => {
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(null);

  if (!isOpen) return null;

  const colorMap = {
    red: { icon: "text-red-400", btn: "bg-red-600 hover:bg-red-700" },
    blue: { icon: "text-blue-400", btn: "bg-blue-600 hover:bg-blue-700" },
    green: { icon: "text-green-400", btn: "bg-green-600 hover:bg-green-700" },
    yellow: { icon: "text-yellow-400", btn: "bg-yellow-600 hover:bg-yellow-700" },
    gray: { icon: "text-gray-400", btn: "bg-gray-600 hover:bg-gray-700" },
  };

  const selectedColor = colorMap[buttonColor] || colorMap.red;

  const handleClick = async (type) => {
    setLoading(true);
    setLoadingButton(type);

    try {
      if (type === "complete") {
        await onCompleteUndo();
      } else if (type === "dealMachine") {
        await onDealMachineUndo();
      }
      onCancel(); // close modal after success
    } catch (err) {
      console.error("Undo action failed:", err);
    } finally {
      setLoading(false);
      setLoadingButton(null);
    }
  };

  return (
    <div className="!fixed !inset-0 !flex !items-center !justify-center !bg-black/50 z-50">
      <div className="!bg-white !rounded-sm !shadow-xl !w-full !max-w-lg">
        {/* Header */}
        <div className="!text-xl !font-normal !text-gray-500 !mb-3 !border-b !border-gray-200 !py-3 !px-6 flex !space-x-2 items-center">
          <TriangleAlert className={selectedColor.icon} />
          <p>{title}</p>
        </div>

        {/* Message */}
        <p className="!text-gray-600 !px-6 !py-2">{message}</p>

        {/* Buttons */}
        <div className="!flex !justify-center !gap-3 !py-3 !px-6">
          {/* Cancel */}
          <button onClick={onCancel} disabled={loading} className="!px-4 !py-2 !rounded-lg !border !border-gray-300 !text-gray-700 hover:!bg-gray-100 !transition cursor-pointer text-nowrap disabled:opacity-50">
            Cancel
          </button>

          {/* Deal Machine Undo */}
          <button onClick={() => handleClick("dealMachine")} disabled={loading} className="!px-4 !py-2 !rounded-lg !bg-blue-600 hover:bg-blue-700 !text-white !transition cursor-pointer text-nowrap disabled:opacity-50">
            {loading && loadingButton === "dealMachine" ? "Processing..." : "Deal Machine Undo"}
          </button>

          {/* Complete Undo */}
          <button onClick={() => handleClick("complete")} disabled={loading} className={`!px-4 !py-2 !rounded-lg !text-white ${selectedColor.btn} !transition cursor-pointer text-nowrap disabled:opacity-50`}>
            {loading && loadingButton === "complete" ? "Processing..." : "Complete Undo"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UndoLeadModal;
